export default {
      id: "ic_tjk_tv-usage",
      viewBox: "0 0 18 19",
      url: "/" + "images/icons.3.109.2.svg#ic_tjk_tv-usage",
      toString: function () {
        return this.url;
      }
    }